/**
 * Carousel: use slick library
 * https://www.npmjs.com/package/slick-carousel
 */

(function() {
    "use strict";

    jQuery('.page-node-type-dispositif .group-header').append(jQuery('.group-right.GridM-3').find('.field--cta-crm').clone().addClass("topButtonAdded"));
    jQuery('.page-node-type-dispositif .group-header').append(jQuery('.group-right.GridM-3').find('.paragraph--type--cta-sidebar').clone().addClass("topButtonAdded"));

    if(jQuery('.group-right.GridM-3').find('.paragraph--type--cta-sidebar')){
      jQuery('.group-right.GridM-3').addClass('removed-tablet')
      jQuery('.group-left.GridM-9').addClass('removed-tablet')
    }


})(jQuery);
